<template>
<div class="font1">
  <div class="line lineHeight" ></div>
  <div class="title tcolor">
    <div class="clm1">注册日期</div>
    <div class="clm2">注册手机</div>
    <div class="clm3">获得积分</div>
  </div>
  <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        @load="getPromoters"
    >
    <div v-for="(item,index) in promoterList"  :key="item.cellPhone+index">
        <div class="content ccolor">
            <div class="clm1">{{item.registerDate}}</div>
            <div class="clm2">{{item.cellPhone}}</div>
            <div class="clm3 award-color">+{{item.rewardQuantity}}</div>
        </div>
    </div>
  </van-list>
  <div class="container footer-container-no-msg" v-if='promoterList.length==0'>
    <div class="line" ></div>
    <img class='logo' src="@/assets/images/pic-no-deal.png" />
    <div class='footer-container-no-item-msg' >
      <div >您尚未进行推广，快快推广赚积分吧</div>
    </div>
  </div>

</div>
</template>
<script>
export default {
    name: '',
    data () {
        return {
            promoterList: [],
            loading: false,
            finished: false,
            pageSize:14,
            pageNum:1
        }
    },
    mounted(){
      this.getPromoters()
      let initTime = this.initTime
        this.$service.getStatisCommon("evn_dom_finish",{initTime:initTime})
    },
    methods: {
      async getPromoters(){
        let toast = this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        let params = {
            memberId: localStorage.getItem(this.$env+"memberId"),
            pageSize: this.pageSize,
            startPage: this.pageNum
        }
        let res = await this.$service.getMyPromotionInfo(params);
        this.loading = false;
        toast.close();
        if(res.status==200){
            if (res.result.length>0) {
                let list = res.result || [];
                this.promoterList = [...this.promoterList, ...list];
                // 如果总页数大于当前页码，页码+1
                this.pageNum++;
            }else{
                this.finished = true;
            }
        }
        let initTime = this.initTime
          this.$service.getStatisCommon("evn_open_page",{initTime: initTime});
      },
    }
}
</script>
<style scoped>
.logo {
  width: 4.3733rem;
  height: 3.2533rem;
  align-self: center;
  margin-top: 2.24rem;
  margin-bottom: 0.2933rem;
  
}
.title {
  display: flex;
  flex-direction: row;
  padding: 0.4rem; 
  border-bottom: 1px solid rgb(236,236,236);
}

.tcolor{
  color: rgb(176,176,176)
}
.ccolor{
  color: rgb(85,85,85)
}
.award-color{
  color: rgb(235,97,18)
}

.content {
  display: flex;
  flex-direction: row;
  padding: 0.4rem; 
  border-bottom: 1px solid rgb(236,236,236);
}

.clm1 {
  width: 50%;
  text-align: center;
}

.clm2 {
  width: 50%;
  text-align: center;
}

.clm3 {
  width: 33.3333333333333%;
  text-align: center;
  display: none;
}

.font1 {
  font-family: PingFang-SC-Medium;
  font-size: 0.4rem;
}

.lineHeight{
  height: 0.1333rem;
}
.footer-container-no-msg{
    text-align: center;
}
</style>
